/**
 * IDs de handles de saída do nó Lista (lst_<id>) — deve coincidir com listNode.js.
 */
export function getListRowId(row) {
  if (row?.id != null && String(row.id).trim() !== "") {
    return String(row.id).trim();
  }
  if (row?.rowId != null && String(row.rowId).trim() !== "") {
    return String(row.rowId).trim();
  }
  return null;
}

export function getListSourceHandleIdsFromSections(sections) {
  const ids = new Set();
  if (!Array.isArray(sections)) return ids;
  sections.forEach((sec) => {
    (sec?.rows || []).forEach((row) => {
      const rowId = getListRowId(row);
      if (rowId) ids.add(`lst_${rowId}`);
    });
  });
  return ids;
}

/** Coleta handles lst_* de um node list ou singleBlock (elements com list). */
export function collectListSourceHandleIds(node) {
  const ids = new Set();
  if (!node) return ids;

  if (node.type === "list") {
    getListSourceHandleIdsFromSections(node.data?.sections).forEach((h) => ids.add(h));
    if (Array.isArray(node.data?.listRows)) {
      node.data.listRows.forEach((row) => {
        const rowId = getListRowId(row);
        if (rowId) ids.add(`lst_${rowId}`);
      });
    }
    return ids;
  }

  if (node.type === "singleBlock") {
    (node.data?.elements || []).forEach((el) => {
      if (el?.type === "list") {
        getListSourceHandleIdsFromSections(el.sections).forEach((h) => ids.add(h));
      }
    });
  }

  return ids;
}
